var _defs, _g, _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _path3, _path4, _path5, _path6, _polygon5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRsRoomLengthRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 325.23 198.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#ea8b77;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:#515353;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1436.96,
    y1: 15.62,
    x2: 1470.96,
    y2: 15.62,
    gradientTransform: "matrix(-1, 0, 0, 1, 1474.99, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db7860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed7159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1163.13,
    y1: 94.49,
    x2: 1461.58,
    y2: 94.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -5214.95,
    y1: -2606,
    x2: -5180.95,
    y2: -2606,
    gradientTransform: "matrix(1, 0, 0, -1, 5503.19, -2433.2)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "28.67 11.04 28.82 23.17 38.1 17.53 37.95 5.39 28.67 11.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "38.03 5.39 4.03 5.74 4.14 25.84 16.16 18.59 26 12.65 38.03 5.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "4.14 25.84 4.1 37.97 13.56 32.33 13.41 20.2 4.14 25.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "28.64 11.04 13.41 20.2 296.62 177.95 311.86 168.79 28.64 11.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.41 20.2 13.56 32.33 296.09 190.09 296.62 177.95 13.41 20.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "288.24 183.03 288.24 195.45 322.39 194.82 322.24 182.68 288.24 183.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "288.24 183.03 322.24 182.68 322.13 162.58 310.1 169.83 300.26 175.77 288.24 183.03"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M121.2,34.81a12.41,12.41,0,0,1,.79,4.36v.73a6.42,6.42,0,0,1-.8,3.43A2.75,2.75,0,0,1,119,44.7a5.74,5.74,0,0,1-3.22-.91l-4.23-2.44,0-15.7,4.2,2.43A11.61,11.61,0,0,1,119,30.87,13.38,13.38,0,0,1,121.2,34.81Zm-2.07,3.53v-.82a9.25,9.25,0,0,0-.85-4.13,6.3,6.3,0,0,0-2.52-2.69l-1.39-.81,0,10.48,1.36.79c1.1.63,1.94.71,2.53.22s.88-1.51.89-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M134.39,38.83l0,10.33q0,2.58-1.41,3.27c-.94.46-2.22.22-3.84-.71a10.65,10.65,0,0,1-3.79-3.66,9.18,9.18,0,0,1-1.43-4.82l0-10.46,2.82,1.63,0,10.36a4.88,4.88,0,0,0,.64,2.61,4.74,4.74,0,0,0,1.77,1.73q2.37,1.38,2.42-1.46l0-10.45Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "142.24 42.29 140.52 41.3 137.69 36.61 137.69 36.52 140.01 37.85 141.38 40.19 142.76 39.44 145.07 40.78 145.07 40.89 142.24 42.29"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "139.64 54.98 146.52 58.95 146.52 61.55 136.12 55.54 136.12 53.65 142.91 46.37 136.17 42.48 136.17 39.86 146.41 45.77 146.41 47.63 139.64 54.98"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "151.33 48.61 151.29 64.3 148.47 62.67 148.51 46.98 151.33 48.61"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "165.04 56.52 164.99 72.21 162.19 70.59 156.74 57.11 156.71 67.43 153.89 65.8 153.94 50.11 156.75 51.74 162.21 65.25 162.24 54.9 165.04 56.52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M174.2,61.81l5.07,18.65-3-1.73L175.34,75,170.4,72.1l-.94,2.69-3-1.72,5.13-12.76Zm-3,8.11,3.42,2L172.89,65l-1.72,4.89"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M190.26,70.87A10.61,10.61,0,0,1,192.87,73a9.73,9.73,0,0,1,1.77,2.74,7.14,7.14,0,0,1,.62,2.89L192.45,77a3.63,3.63,0,0,0-.59-2,4.59,4.59,0,0,0-1.65-1.56A2.24,2.24,0,0,0,188.6,73c-.38.12-.57.45-.58,1a2.85,2.85,0,0,0,.67,1.67,16.12,16.12,0,0,0,2,2.11,18.63,18.63,0,0,1,3.49,4.08,7.09,7.09,0,0,1,1.09,3.69q0,2-1.35,2.43c-.89.25-2.1,0-3.61-.93a11.9,11.9,0,0,1-2.87-2.32,11.18,11.18,0,0,1-2-2.95,7.64,7.64,0,0,1-.67-3.07l2.82,1.62a4.67,4.67,0,0,0,2.69,4.16,2.27,2.27,0,0,0,1.58.44c.37-.09.56-.43.56-1a3,3,0,0,0-.56-1.74,16.22,16.22,0,0,0-2-2.2,30,30,0,0,1-2.31-2.41,8.32,8.32,0,0,1-2.32-5.23,2.6,2.6,0,0,1,.63-1.91,2.08,2.08,0,0,1,1.8-.52A6.56,6.56,0,0,1,190.26,70.87Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M207.66,84.57a14.21,14.21,0,0,1,.72,4.49v.7a7.75,7.75,0,0,1-.72,3.65,2.64,2.64,0,0,1-2.05,1.51,4.89,4.89,0,0,1-3-.8,10.47,10.47,0,0,1-3-2.69,12.76,12.76,0,0,1-2.05-3.86,13.73,13.73,0,0,1-.73-4.44v-.78a7.61,7.61,0,0,1,.74-3.65,2.65,2.65,0,0,1,2.06-1.52,4.9,4.9,0,0,1,3,.8,10.59,10.59,0,0,1,3,2.7A12.88,12.88,0,0,1,207.66,84.57Zm-2.13,3.6V87.4a10.49,10.49,0,0,0-.76-4.19,5.37,5.37,0,0,0-2.2-2.56c-.94-.54-1.67-.54-2.18,0s-.78,1.64-.79,3.26v.77a10.28,10.28,0,0,0,.77,4.17,5.23,5.23,0,0,0,2.2,2.6c.95.55,1.68.54,2.18,0a5.09,5.09,0,0,0,.79-3.27"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M220,97.09a5.94,5.94,0,0,1,.6,2.58c0,1.51-.43,2.42-1.27,2.71s-2,0-3.58-.89l-5.31-3.06,0-15.7,4.78,2.76A11.52,11.52,0,0,1,219,88.77a6.72,6.72,0,0,1,1.28,4,2.55,2.55,0,0,1-.53,1.73,1.49,1.49,0,0,1-1.43.46A6.59,6.59,0,0,1,220,97.09Zm-2.78,2.11c.38-.15.56-.54.56-1.18a3.61,3.61,0,0,0-1.93-3.31l-2.58-1.49v4.23l2.41,1.4a1.92,1.92,0,0,0,1.55.35M213.25,87v4l2.08,1.2c1.42.8,2.13.56,2.14-.71a3.25,3.25,0,0,0-.54-1.85,5.19,5.19,0,0,0-1.71-1.46l-2-1.13"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "231.84 95.09 231.83 97.71 225.51 94.06 225.5 97.8 230.9 100.92 230.89 103.43 225.49 100.31 225.48 104.53 231.82 108.19 231.81 110.79 222.65 105.5 222.7 89.81 231.84 95.09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsRoomLengthRed);
export default __webpack_public_path__ + "static/media/rs-room-length-red.68880075164920032e6147d499c41807.svg";
export { ForwardRef as ReactComponent };